import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { AuthService } from '../core-api/services/auth/auth.service';
import { PlatformService } from '../core-api/platform/platform.service';
import { SignalRService } from '../core-api/signalr/signalr.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalNotificationsService {
    serviceInitated = false;
    fetchingNotification = false;
    intervalId: any;
    
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private _authService: AuthService,
        private _signalRService: SignalRService,
        protected _platformService: PlatformService,
    ) {
        this._authService.authenticationState$.subscribe(async _isAuthenticated => {
            if (_isAuthenticated) {
                if (!this.serviceInitated) {
                    this.serviceInitated = true;
                    await this.doFetchNotifications();
                }
                if (!this.intervalId) { 
                    this.intervalId = setInterval(() => {
                    if (this.fetchingNotification) { return; }
                    this.doFetchUnreadNotifications();
                }, 30000); }
            } else {
                this.serviceInitated = false;
                if (!!this.intervalId) { clearInterval(this.intervalId); }
            }
        });
    }

    async doFetchNotifications() {
        this.fetchingNotification = true;
        try {
            const notifications = await this._httpClient.get<any[]>(this._apiService.endPoints.doGetNotificationsAction_Notification).toPromise();
            await this.processNotifications(notifications);
            this.fetchingNotification = false;
        } catch {
            this.fetchingNotification = false;
        }
    }
    
    async doFetchUnreadNotifications() {
        this.fetchingNotification = true;
        try {
            const incomeNotifications = await this._httpClient.get<any[]>(this._apiService.endPoints.doGetUnreadNotificationAction_Notification).toPromise();
            await this.processNotifications(incomeNotifications, true);

            this.fetchingNotification = false;
        } catch {
            this.fetchingNotification = false;
        }
    }

    private async processNotifications(incomeNotifications: any[], isTimeoutRequest?: boolean) {
        incomeNotifications = incomeNotifications.sort((a,b) => {
            const posA = a.READED == true ? 1 : 0; 
            const posB = b.READED == true ? 1 : 0; 
            return posA - posB;
        });
        const unreadedNotifications = incomeNotifications.filter(notification => notification.READED == false);
        const showingNotifications = unreadedNotifications.filter(notification => notification.SHOW_NOTIFICATION == true);
        if (showingNotifications.length > 1) {
            this._platformService.showNotification('Abworkflow', `Vous avez ${showingNotifications.length} nouvelle(s) notification(s)`);
        }
        else if (showingNotifications.length == 1 && !!showingNotifications[0].NOTIFICATION_DATAS) {
            this._platformService.showNotification('Abworkflow', showingNotifications[0].NOTIFICATION_DATAS.MESSAGE);
        }

        for (var n in unreadedNotifications) {
            const notification = JSON.parse(JSON.stringify(unreadedNotifications[n]));
            notification.TYPE_LIVE_NOTIFICATION = notification.TYPE_NOTIFICATION;
            notification.NOTIFICATION_DATAS = JSON.stringify(notification.NOTIFICATION_DATAS);
            this._signalRService.eventListener$.next({ event: "SHOW_NOTIFICATION", datas: notification });
        }

        if (unreadedNotifications.length > 0) {
            await this._httpClient.post<void>(this._apiService.endPoints.doMarkNotificationsAsReadAction_Notification, { NOTIFICATIONS_IDS: unreadedNotifications.map(notification => notification.ID) }).toPromise();
            if (isTimeoutRequest == true) {
                let notificationsHandled = this._signalRService.notificationsHandled$.value;
                notificationsHandled = unreadedNotifications.filter(notification => notificationsHandled.findIndex(n => n.ID == notification.ID) == -1).concat(notificationsHandled);
                this._signalRService.notificationsHandled$.next(notificationsHandled);
            }
        }
        if (!isTimeoutRequest) {
            this._signalRService.notificationsHandled$.next(incomeNotifications);
        }
    }
}